import { render, staticRenderFns } from "./ProfileCharts.vue?vue&type=template&id=1749fee3&scoped=true"
import script from "./ProfileCharts.vue?vue&type=script&lang=js"
export * from "./ProfileCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1749fee3",
  null
  
)

export default component.exports